import Log from '@lib/Log'
import * as Sentry from '@sentry/react'
const { version } = require('../../package.json')
const { NODE_ENV, SENTRY_DSN } = process.env

const isDevEnv = NODE_ENV !== 'production'

export const initSentry = (mode: string) => {
  if (process.env.NODE_ENV !== 'production') {
    Log.info(window, 'Skipping Sentry initialization in non-prod environment');
    return;
  }
  try {
    Sentry.init({
      dsn: isDevEnv ? 'https://123@test.ingest.sentry.io/1111111' : SENTRY_DSN,
      release: `${mode}@${version}`,
    })
  } catch (error) {
    Log.error(window, `Sentry not initialized: ${error.message}`)
  }
}
